var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 7.99998H7.99998V3.33331C7.99998 2.93331 7.73331 2.66665 7.33331 2.66665C3.99998 2.66665 1.33331 5.33331 1.33331 8.66665C1.33331 12 3.99998 14.6666 7.33331 14.6666C10.6666 14.6666 13.3333 12 13.3333 8.66665C13.3333 8.26665 13.0666 7.99998 12.6666 7.99998ZM7.99998 13.2666C5.46665 13.6666 3.06665 11.8666 2.73331 9.33331C2.33331 6.79998 4.13331 4.39998 6.66665 4.06665V8.66665C6.66665 9.06665 6.93331 9.33331 7.33331 9.33331H11.9333C11.6666 11.4 10.0666 13 7.99998 13.2666ZM9.99998 1.33331C9.59998 1.33331 9.33331 1.59998 9.33331 1.99998V5.99998C9.33331 6.39998 9.59998 6.66665 9.99998 6.66665H14C14.4 6.66665 14.6666 6.39998 14.6666 5.99998C14.6666 3.39998 12.6 1.33331 9.99998 1.33331ZM10.6666 5.33331V2.73331C12 2.99998 13 3.99998 13.2666 5.33331H10.6666Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.97e761a22cd3158f37464846bfe66beb.svg";
export { ForwardRef as ReactComponent };